export function estimatedMinutesFromHours(value) {
  if (value === null || value === undefined || value === "") {
    return 0;
  }

  const normalized = String(value).trim().replace(",", ".");
  const hours = Number(normalized);

  if (!Number.isFinite(hours) || hours <= 0) {
    return 0;
  }

  return Math.max(1, Math.round(hours * 60));
}

export function estimatedMinutesFromParts(hoursValue, minutesValue) {
  const hours = Number.parseInt(String(hoursValue || "0"), 10) || 0;
  const minutes = Number.parseInt(String(minutesValue || "0"), 10) || 0;

  if (hours < 0 || minutes < 0 || minutes > 59) {
    return 0;
  }

  return hours * 60 + minutes;
}

export function durationPartsFromMinutes(minutes) {
  const value = Number(minutes);

  if (!Number.isFinite(value) || value <= 0) {
    return { hours: "", minutes: "00" };
  }

  return {
    hours: String(Math.floor(value / 60)),
    minutes: String(value % 60).padStart(2, "0"),
  };
}

export function normalizeMinutePart(value) {
  return String(
    Math.min(59, Math.max(0, Number.parseInt(value || "0", 10) || 0)),
  ).padStart(2, "0");
}

export function hoursInputFromMinutes(minutes) {
  const value = Number(minutes);

  if (!Number.isFinite(value) || value <= 0) {
    return "";
  }

  return String(Number((value / 60).toFixed(2)));
}

export function calculatedScheduledEnd(start, estimatedDurationMinutes, assignedEmployeeCount) {
  if (!start || !estimatedDurationMinutes) {
    return null;
  }

  const startDate = new Date(start);

  if (Number.isNaN(startDate.getTime())) {
    return null;
  }

  const durationMs = Math.round(
    (estimatedDurationMinutes * 60000) / Math.max(1, assignedEmployeeCount || 0),
  );

  return new Date(startDate.getTime() + Math.max(1, durationMs));
}
